// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","178":"1954d05d","202":"e075aa0c","274":"8ca5e8a0","755":"0827cb3a"}[chunkId] + ".chunk.js";
};